
import { defineComponent, PropType, ref, watch } from 'vue'
import { ElSelect, ElOption } from 'element-plus'

interface Option {
  value: string | number
  label: string
}

export default defineComponent({
  name: 'ElSelectExt',
  components: {
    ElSelect,
    ElOption
  },
  props: {
    modelValue: {
      type: [String, Number] as PropType<string | number>,
      default: null
    },
    options: {
      type: Array as PropType<Option[]>,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(props, { emit }) {
    const selectedValue = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newValue) => {
        selectedValue.value = newValue
      }
    )

    const handleChange = (value: string | number) => {
      emit('update:modelValue', value)
      emit('change', value)
    }

    return {
      selectedValue,
      handleChange
    }
  }
})
